/**
 *
 *调用弹出提示语
 * @class nsToastr
 */
declare const window:any;
class NSToastr {
    public message: string;//提示语
    public state: string;//状态
	public icon: string;//输出图标
	public position: string;//输出位置
	public userLang: string;//输出语言
	public timer:number;//显示时间
	public containerID:string;//实例化的dom元素
	public logsArray:any;
	public logsData:any;//日志名字
	static containerID: string = 'toast-container';//输出容器的id
	static bodyDom:any = document.querySelector('body');//dom元素
    static I18n: object = {
        zh:{
			cancel: "取消",
			complete: "完成",
			determine: "确定",
			deyk: "有误",
			error: "错误",
			fail: "失败",
			prohibit: "禁止",
			prompt: "提示",
			remind: "提醒",
			success: "成功",
			unable: "无法",
			warning: "警告",
		},
		en:{
			cancel: "cancel",
			complete: "complete",
			determine: "confirm",
			deyk: "has error",
			error: "error",
			fail: "fail",
			prohibit: "prohibit",
			prompt: "prompt",
			remind: "remind",
			success: "success",
			unable: "unable",
			warning: "warning",
		}
    };
    remove():void {
		//隐藏提示语
		//document.querySelector
		let containerDom:any = window.jQuery('#'+`${this.containerID}`);
		if(containerDom.length === 1){
			containerDom.remove();
		}
	}
	clear():void{
		let containerDom:any = window.jQuery('#'+`${NSToastr.containerID}`);
		if(containerDom.length === 1){
			containerDom.remove();
		}
	}
	show():void{
		//显示提示语
		this.getHtml();
		let _this = this;
		let tempTimer = _this.timer;
		if(typeof(tempTimer) !=='number'){
			if(_this.state == "error" || _this.state == "warning"){
				tempTimer = 5000;
			}
		}
		setTimeout(function(){
			_this.remove();
		},tempTimer)
	}
	private getHtmlByItemData(itemObj:any,isSampleOut:boolean){
		let simpleHtml = ``;
		let returnHtml = ``;
		let $ = window.jQuery;
		for(let itemI in itemObj){
			switch(typeof(itemObj[itemI])){
				case 'object':
					if(isSampleOut === false){
						let deepHtml = '';
						for(let deepI in itemObj[itemI]){
							switch(typeof(itemObj[itemI][deepI])){
								case 'string':
									let encodeStr = itemObj[itemI][deepI];
									if(typeof(encodeStr)=='string'){
										encodeStr = window.NSUtils.htmlCode.encodeHtml(encodeStr);
									}else if(typeof(encodeStr)=='object'){
										encodeStr = JSON.stringify(encodeStr);
									}
									deepHtml += `<li><span class="title">${deepI}:</span><span class="text">${encodeStr}</span></li>`;
									break;
								case 'object':
									if(Array.isArray(itemObj[itemI][deepI])){
										let arrayString = JSON.stringify(itemObj[itemI][deepI],null,4);
										deepHtml += `<li><span class="title">${deepI}:</span><span class="text"><pre>${arrayString}</pre></span></li>`;
									}else{
										for(var eachI in itemObj[itemI][deepI]){
											let encodeStr = itemObj[itemI][deepI][eachI];
											if(typeof(encodeStr)=='string'){
												encodeStr = window.NSUtils.htmlCode.encodeHtml(encodeStr);
											}else if(typeof(encodeStr)=='object'){
												encodeStr = '<pre>'+JSON.stringify(encodeStr,null,4)+'</pre>';
											}
											deepHtml += `<li><span class="title">${eachI}:</span><span class="text">${encodeStr}</span></li>`;
										}
									}
									break;
							}
						}
						returnHtml += `<div class="alert-block-item open">`
										+`<div class="alert-block-item-header">`
											+`<span>${itemI}</span>`
											+`<span class="control"><i class="icon-add"></i></span>`
										+`</div>`
										+`<div class="alert-block-item-body">`
											+`${deepHtml}`
										+`</div>`
									+`</div>`;
					}
					break;
				default:
					simpleHtml += `<li><span class="title">${itemI}:</span><span class="text">${itemObj[itemI]}</span></li>`;
					break;
			}
		}
		if(simpleHtml){
			returnHtml = `<div class="alert-block-item open">`
							//+`<div class="alert-block-item-header">`
								//+`<span>base</span>`
								//+`<span class="control"><i class="icon-add"></i></span>`
							//+`</div>`
							+`<div class="alert-block-item-body">`
								+`${simpleHtml}`
							+`</div>`
						+`</div>`+returnHtml;
		}
		return returnHtml;
	}
	private getContentHtml(indexI:any){
		let itemObject = this.logsArray[indexI];
		let headerLiHtml = `<li class="alert-nav-item current">默认</li>`;
		let contentBaseLiHtml = ``;
		let $ = window.jQuery;
		for(let itemI in itemObject){
			switch(typeof(itemObject[itemI])){
				case 'object':
					headerLiHtml += `<li class="alert-nav-item" li-field="${itemI}">${itemI}</li>`;
					break;
				default:
					let encodeStr = itemObject[itemI];
					if(typeof(encodeStr)=='string'){
						encodeStr = window.NSUtils.htmlCode.encodeHtml(encodeStr);
					}else if(typeof(encodeStr)=='object'){
						encodeStr = '<pre>'+JSON.stringify(encodeStr,null,4)+'</pre>';
					}
					contentBaseLiHtml += `<li><span class="title">${itemI}:</span><span class="text">${encodeStr}</span></li>`;
					break;
			}
		}
		let contentBaseHtml = `<div class="alert-block-item open">`
									//+`<div class="alert-block-item-header">`
										//+`<span>base</span>`
										//+`<span class="control"><i class="icon-add"></i></span>`
									//+`</div>`
									+`<div class="alert-block-item-body">`
										+`${contentBaseLiHtml}`
									+`</div>`
								+`</div>`;
		return `<div class="alert-col" ns-tabcontent="true">`
					+`<div class="col-header">`
						+`<ul class="alert-nav-list" id="nstoastr-menu-tab-list" ns-index="${indexI}">${headerLiHtml}</ul>`
					+`</div>`
					+`<div class="col-body">`
						+`<div class="alert-block-list">`
							+`${contentBaseHtml}`
						+`</div>`
					+`</div>`
				+`</div>`;
	}
	private changeTabClickHandler(tabLiEvent:any){
		let $ = window.jQuery;
		let _this:any = tabLiEvent.data.data;
		let $Li = $(this);
		let nsIndex:any = $Li.closest('ul').attr('ns-index');
		let nsFieldStr:any = $Li.attr('li-field');
		let currentObject = _this.logsArray[nsIndex][nsFieldStr];
		let isSimpleOut = false;
		if(typeof(nsFieldStr)=='undefined'){
			currentObject = _this.logsArray[nsIndex];
			isSimpleOut = true;
		}
		let contentHTML = _this.getHtmlByItemData(currentObject,isSimpleOut);
		let $divContainer = $Li.closest('div.alert-col').find('div.alert-block-list');
		$Li.addClass('current');
		$Li.siblings().removeClass('current');
		$divContainer.html(contentHTML);
	}
	private tabInit(){
		let $ = window.jQuery;
		let _this = this;
		$('#alert-debug-close-btn').off('click');
		$('#alert-debug-close-btn').on('click',function(closeBtnEvent){
			$(this).closest('div.alert-debug-console').remove();
		});
		$('#nstoastr-menu-list > li').on('click',function(liEvent){
			let $Li = $(this);
			let nsIndex:any = $Li.attr('ns-index');
			let $divContainer = $Li.closest('div.alert-row');
			let contentHTML = _this.getContentHtml(nsIndex);
			$Li.addClass('current');
			$Li.siblings().removeClass('current');
			$divContainer.children('div[ns-tabcontent="true"]').remove();
			$divContainer.append(contentHTML);
			$('#nstoastr-menu-tab-list > li').off('click',_this.changeTabClickHandler);
			$('#nstoastr-menu-tab-list > li').on('click',{data:_this},_this.changeTabClickHandler);
		})
		$('#nstoastr-menu-tab-list > li').on('click',{data:_this},_this.changeTabClickHandler);
	}
	private initEvent(){
		let _this = this;
		let $ = window.jQuery;
		$('#'+this.containerID).on('click',function(domEvent){
			if(!$.isEmptyObject(_this.logsData)){
				let urlSuffixObj:any = {
					suffix:'/midware/log/'+_this.logsData.logFileName,
					urlType:'web'
				};
				let logsAjaxConfig = {
					url:window.NSUtils.getUrl(urlSuffixObj),
					method:"get",
					data:{}
				};
				window.NSUtils.ajax(logsAjaxConfig,function(logsRes:any){
					if(Array.isArray(logsRes)){
						_this.logsArray = logsRes;
						let titleLiHtml = '';//左侧显示的选项卡
						for(let logI=0; logI<logsRes.length; logI++){
							let currentClassStr = logI === 0 ? 'current' : '';
							if(logsRes[logI].type){
								currentClassStr += ' alert-'+logsRes[logI].type;
							}else{
								currentClassStr +=' alert-info';
							}
							if(typeof(logsRes[logI].source)=='object'){
								if(Array.isArray(logsRes[logI].source)){
									let arrayStr = JSON.stringify(logsRes[logI].source);
									titleLiHtml +=`<li class="alert-menu-item ${currentClassStr}" ns-index="${logI}">`
												+`<span>${arrayStr}</span>`
											+`</li>`;
								}else{
									for(var eachLogI in logsRes[logI].source){
										titleLiHtml +=`<li class="alert-menu-item ${currentClassStr}" ns-index="${eachLogI}">`
												+`<span>${logsRes[logI].source[eachLogI]}</span>`
											+`</li>`;
									}
								}
							}else{
								titleLiHtml +=`<li class="alert-menu-item ${currentClassStr}" ns-index="${logI}">`
												+`<span>${logsRes[logI].source}</span>`
											+`</li>`;
							}
						}
						let baseTabHtml = `<div class="alert-col"><ul class="alert-menu-list" id="nstoastr-menu-list">${titleLiHtml}</ul></div>`;


						let contentTabHtml = _this.getContentHtml(0);
						let headerHtml = '';
						for(let bugI in _this.logsData){
							if(bugI === 'logFileName'){
								continue;
							}
							if(bugI === 'NETSTAR-URL'){
								continue;
							}
							switch(typeof(_this.logsData[bugI])){
								case 'object':
									break;
								default:
									let encodeStr = _this.logsData[bugI];
									if(typeof(encodeStr)=='string'){
										encodeStr = window.NSUtils.htmlCode.encodeHtml(encodeStr);
									}
									headerHtml += `<li><span class="title">${bugI}:</span><span class="text">${encodeStr}</span></li>`;
									break;
							}
						}
						var urlTitleHtml = '';
						if(_this.logsData['NETSTAR-URL']){
							let urlStr = _this.logsData['NETSTAR-URL'].substring(window.NSUtils.getUrl().length-1,_this.logsData['NETSTAR-URL'].length);
							urlTitleHtml = `<div class="alert-url-title"><span class="title">url:</span><span class="text">${urlStr}</span></div>`;
						}
						let appendHtml = `<div class="alert-debug-console">`
											+`<div class="alert-debug-console-header">`
												+`<div class="alert-debug-console-header-title">`
													+`${urlTitleHtml}`
													+`<button class="pt-btn pt-btn-icon" type="button" id="alert-debug-close-btn"><i class="icon-close"></i></button>`
												+`</div>`
												+`<div class="alert-debug-console-header-body">`
													+`${headerHtml}`
												+`</div>`
											+`</div>`
											+`<div class="alert-debug-console-body">`
												+`<div class="alert-row">`
													+`${baseTabHtml}`
													+`${contentTabHtml}`
												+`</div>`
											+`</div>`
										+`</div>`;
						$('.alert-debug-console').remove();
						$('#'+_this.containerID).remove();
						$('body').append(appendHtml);
						let documentHeight:number = Number($(document).outerHeight());
						let headerHeight:number = Number($('div.alert-debug-console > div.alert-debug-console-header').outerHeight());
						let bodyHeight = documentHeight - headerHeight;
						$('.alert-debug-console-body').css('height',bodyHeight+'px');
						_this.tabInit();
					}
				},function(){

				})
			}else{
				
			}
		})
	}
    private getHtml(){
		let $ = window.jQuery;
		let i18n = (<any>NSToastr.I18n)[`${this.userLang}`];
		let bgClass = '';
		let iconClass = '';
		let stateClass = 'info';
		let messageStr = this.message;
		if(this.state === ''){
			if(messageStr.indexOf(i18n.success)>-1||messageStr.indexOf(i18n.complete)>-1){
				iconClass = '<i class="fa fa-check"></i> ';
				stateClass = 'success';
			}else if(messageStr.indexOf(i18n.fail)>-1||messageStr.indexOf(i18n.error)>-1||messageStr.indexOf("error")>-1||messageStr.indexOf(i18n.deyk)>-1){
				iconClass = '<i class="fa fa-warning"></i> ';
				stateClass = 'error';
			}else if(messageStr.indexOf(i18n.remind)>-1||messageStr.indexOf(i18n.warning)>-1||messageStr.indexOf(i18n.prompt)>-1||messageStr.indexOf(i18n.unable)>-1||messageStr.indexOf(i18n.prohibit)>-1){
				iconClass = '<i class="fa fa-warning"></i> ';
				stateClass = 'warning';
			}
		}else{
			stateClass = this.state;
		}
		if(this.icon){
			iconClass = '<i class="fa fa-'+this.icon+'"></i> ';
		}
		if(iconClass==''){
			if(stateClass == "error"||stateClass == "warning"){
				iconClass = '<i class="fa fa-warning"></i> ';
			}else if(stateClass == "success"){
				iconClass = '<i class="fa fa-check"></i> ';
			}else if(stateClass == "info"){
				iconClass = '<i class="fa fa-comment"></i> ';
			}else{
				iconClass = '<i class="fa fa-comment"></i> ';
			}
		}
		bgClass = 'toast-'+stateClass;
		let html = `<div class="toast ${bgClass} ${this.position}" id="${this.containerID}">`
						+`<div class="toast-message">`
							+`${iconClass}${messageStr}`
						+`</div>`
					+`</div>`;
		let containerDom:any = $('#nstoastr-msginfo');
		if(containerDom.length === 0){
			//当前不存在输出容器
			let bodyClassStr:string = '';
			if(typeof(window.NetstarApiConfig)=='object'){
				if(window.NetstarApiConfig.alertPosition){
					bodyClassStr = window.NetstarApiConfig.alertPosition;
				}
			}
			let toastrHtml = `<div class="nstoastr-body ${bodyClassStr}" id="nstoastr-msginfo">`
								+`${html}`
							+`</div>`;
			$('body').append(toastrHtml);
		}else{
			containerDom.append(html);
		}
		this.initEvent();
    }
    constructor(message:string,logsData?:any,state?:string,icon?:string,position?:string,userLang?:string,timer?:number) {
        this.message = message;
		this.state = state ? state : '';
		this.icon = icon ? icon :'';
		//this.position = position ? position :'top-right';
		this.userLang = userLang ? userLang :'zh';
		this.timer = timer ? timer : 2000;
		this.logsData = typeof(logsData)=='object' ? logsData : {};
		this.containerID = NSToastr.containerID + '-'+Math.floor(Math.random()*10000000000+1);
		if(position){
			this.position = position;
		}else{
			let positionStr:string = 'top-right';
			if(typeof(window.NetstarApiConfig)=='object'){
				if(window.NetstarApiConfig.alertPosition){
					positionStr = window.NetstarApiConfig.alertPosition;
				}
			}
			this.position = positionStr;
		}
    }
}
export default NSToastr;
